"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Interceptor = /** @class */ (function () {
    function Interceptor() {
    }
    Interceptor.prototype.intercept = function (methodContext, chain) {
        this.before(methodContext);
        var result = chain.proceed(methodContext);
        this.after(methodContext, result);
        return result;
    };
    return Interceptor;
}());
exports.default = Interceptor;
